export default __webpack_public_path__ + "static/media/conference-room-image.0576dd02.svg";